/**
 * `/admin/project-type-presets` — i modelli di commessa, dalla piattaforma.
 *
 * ⚠️ La schermata **non sta qui**: è `ProjectTypePresetsPanel`, perché la rende anche la sezione
 * «Modelli commessa» di «Regole di lavoro». Questa rotta resta per i link già in giro.
 */
import { createFileRoute } from '@tanstack/react-router';
import { ProjectTypePresetsPanel } from '@/features/projects/ProjectTypePresetsPanel';

export const Route = createFileRoute('/_app/admin/project-type-presets')({
  component: ProjectTypePresetsPanel,
});
